import { useEffect, useState } from 'react';

import useNoodleApi from '@/hooks/useNoodleApi';
import getQuestionnaireAgents from '@/tsClient/questionnaires/getQuestionnaireAgents';
import { type Agent } from '@/typings/api-models';

const useLoadAgents = ({
  creatorId,
  questionnaireTemplateId,
}: {
  creatorId: string;
  questionnaireTemplateId: string;
}): Agent[] | null => {
  const [agentsLoaded, setAgentsLoaded] = useState(false);
  const { data: response, getData: getQuestionnaireAgentsFn } = useNoodleApi(getQuestionnaireAgents);

  useEffect(() => {
    const getAgents = async (): Promise<void> => {
      if (creatorId) {
        setAgentsLoaded(false);
        await getQuestionnaireAgentsFn({
          creatorId,
          page: 1,
          perPage: 100_000,
          questionnaireTemplateId,
        });
        setAgentsLoaded(true);
      }
    };
    getAgents();
  }, [getQuestionnaireAgentsFn, creatorId, questionnaireTemplateId]);

  return agentsLoaded && response ? response.items : null;
};

export default useLoadAgents;
